// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"10b347f4","817":"ed96256c","946":"91910f4d"}[chunkId] + ".chunk.js";
};